export default __webpack_public_path__ + "static/media/heart.75d74a25.svg";